import React, { useEffect, useState, useRef } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMyContext } from '../../../context/MyContext';
import '../../../css/custom-scrollbar.css';
import { Base_Url, editwarehouse, getpincode } from '../../../config/config';
import { toast } from 'react-toastify';
import axios from 'axios';
import {
  Building2,
  User,
  MapPin,
  Calendar,
  Hash,
  X,
  Edit3,
  Save,
  RotateCcw,
  Eye,
  Lock,
  AlertCircle
} from "lucide-react";

const schema = z.object({
  Name: z.string()
    .min(1, "Name is required")
    .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabetic characters"),

  email: z.string()
    .email("Invalid email address"),
  phone: z.string()
    .length(10, "Phone number must be exactly 10 digits")
    .regex(/^\d+$/, "Phone number must be numeric"),
  contact_person: z.string()
    .min(1, "contact_person is required")
    .regex(/^[a-zA-Z\s]+$/, "contact_person must only contain alphabetic characters"),
  date: z.string().min(1, "Add Date is required"),
  address: z
    .string()
    .min(1, "Address is required")
    .regex(/^[^#\\%&;]*$/, "Address contains invalid characters (# \\ % & ; not allowed)"),
  pincode: z.string()
    .length(6, "Pincode must be exactly 6 characters")
    .regex(/^\d+$/, "Pincode must be numeric"),
  city: z.string()
    .min(1, "City is required")
    .regex(/^[A-Za-z\s]+$/, "City must only contain letters and spaces"),
  state: z.string()
    .min(1, "State is required")
    .regex(/^[A-Za-z\s]+$/, "State must only contain letters and spaces"),
  country: z.string()
    .min(1, "Country is required")
    .regex(/^[A-Za-z\s]+$/, "Country must only contain letters and spaces"),
  registerName: z.string()
    .min(1, "Register Name is required")
    .regex(/^[a-zA-Z\s]+$/, "Register Name must only contain alphabetic characters"),
  returnAddress: z.string().optional(),
  returnPhone: z.string().optional(),
  returnPincode: z.string().optional(),
  returnCity: z.string().optional(),
  returnState: z.string().optional(),
  returnCountry: z.string().optional(),
});

const ViewWarehouse = ({ isopen, onClose, warehouse }) => {
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const { isDarkMode } = useMyContext();
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditId] = useState(true);
  const [isEditEmail] = useState(true);
  const contentRef = useRef(null);
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm({
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    if (isopen && contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [isopen]);

  useEffect(() => {
    if (warehouse) {
      reset({
        Id: warehouse.id || '',
        Name: warehouse.name || '',
        email: warehouse.email || '',
        phone: warehouse.phone || '',
        contact_person: warehouse.contact_person || '',
        date: warehouse.create_date || '',
        address: warehouse.address || '',
        pincode: warehouse.pincode || '',
        city: warehouse.city || '',
        state: warehouse.state || '',
        country: warehouse.country || '',
        registerName: warehouse.name || '',
        returnAddress: warehouse.return_address || '',
        returnPhone: warehouse.return_phone || '',
        returnPincode: warehouse.return_pincode || '',
        returnCity: warehouse.return_city || '',
        returnState: warehouse.return_state || '',
        returnCountry: warehouse.return_country || '',
      });
    }
  }, [warehouse, reset]);

  const onErrors = () => {
    toast.error("Please fix the errors in the form.");
  };

  const onSubmit = async (data) => {
    const editWarehouseurl = Base_Url + editwarehouse;
    try {
      const payload = {
        customer_id: cusid,
        id: warehouse.id,
        name: data.Name,
        email: data.email,
        phone: data.phone,
        contact_person: data.contact_person,
        address: data.address,
        pincode: data.pincode,
        city: data.city,
        state: data.state,
        country: data.country,
        return_address: data.returnAddress,
        return_phone: data.returnPhone,
        return_pincode: data.returnPincode,
        return_city: data.returnCity,
        return_state: data.returnState,
        return_country: data.returnCountry,
        create_date: data.date,
      };
      const response = await axios.post(editWarehouseurl, payload, {
        headers: {
          'token': token,
          'cus_id': cusid,
          'Content-Type': 'application/json',
        },
      });
      if (response.data.status === "success") {
        toast.success(response.data.message);
        setIsEditMode(false);
        onClose();
      } else {
        toast.error(response.data.message || 'Failed to update warehouse');
      }
    } catch (error) {
      const errorMessagecontact_person = error.response?.data?.errors?.contact_person || "";
      const address = error.response?.data?.errors?.address || "";
      const email = error.response?.data?.errors?.email || "";
      const name = error.response?.data?.errors?.name || "";
      const return_country = error.response?.data?.errors?.return_country || "";
      const return_address = error.response?.data?.errors?.return_address || "";
      const return_pincode = error.response?.data?.errors?.return_pincode || "";
      const return_city = error.response?.data?.errors?.return_city || "";
      const return_state = error.response?.data?.errors?.return_state || "";
      const customer_id = error.response?.data?.errors?.customer_id || "";
      toast.error(errorMessagecontact_person || address || return_country || name || return_address || return_pincode || return_city || return_state || customer_id || email);
    }
  };

  const handleClose = () => {
    setIsEditMode(false);
    onClose();
  };

  const hanldeAllEditFileds = () => {
    setIsEditMode(!isEditMode);
  };

  const fetchPincodeData = async (pincode) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      if (data && data.status === "SUCCESS") {
        let { city, state } = data.data[0];
        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
        state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
        setValue("city", city);
        setValue("state", state);
      } else if (data && data.message === "Unauthorized access - Invalid token") {
        // Handled by global interceptor
      } else if (data && data.status === "FAIL") {
        toast.error("Something Went Wrong Please Try Again With Another Pincode");
      } else {
        toast.error("Failed to fetch city and state data");
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
    }
  };

  const fetchreturnPincodeData = async (returnPincode) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${returnPincode}`;
    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      if (data && data.status === "SUCCESS") {
        let { city, state } = data.data[0];
        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
        state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
        setValue("returnCity", city);
        setValue("returnState", state);
      } else if (data && data.message === "Unauthorized access - Invalid token") {
        // Handled by global interceptor
      } else if (data && data.status === "FAIL") {
        toast.error("Something Went Wrong Please Try Again With Another Pincode");
      } else {
        toast.error("Failed to fetch city and state data");
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
    }
  };

  const handleInputChange = (event) => {
    const { value, id } = event.target;
    if (['pincode', 'phone', 'return-pincode'].includes(id)) {
      const filteredValue = value.replace(/[^0-9]/g, '');
      event.target.value = filteredValue;
      if (id === 'return-pincode' && filteredValue.length === 6) {
        fetchreturnPincodeData(filteredValue);
      }
      if (id === 'pincode' && filteredValue.length === 6) {
        fetchPincodeData(filteredValue);
      }
    }
    if (['facility-name', 'city', 'contact-person', 'state', 'returnState', 'returnCity', 'returnCountry', 'country'].includes(id)) {
      const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
      event.target.value = filteredValue;
    }
  };

  const inputClass = (isEditable, hasError) => `
    w-full px-3 py-2 text-xs rounded-xl border transition-all duration-200 outline-none
    ${hasError
      ? 'border-rose-500 bg-rose-50/40 dark:bg-rose-950/30 text-rose-900 dark:text-rose-200 ring-2 ring-rose-500/20'
      : isEditable
        ? isDarkMode
          ? 'bg-slate-800/80 border-slate-700 text-white placeholder-slate-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/25'
          : 'bg-white border-slate-300 text-slate-900 placeholder-slate-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 shadow-2xs'
        : isDarkMode
          ? 'bg-slate-800/40 border-slate-800/80 text-slate-300 cursor-default select-all'
          : 'bg-slate-100/70 border-slate-200/80 text-slate-700 cursor-default select-all'
    }
  `;

  const labelClass = `
    flex items-center justify-between text-[10.5px] font-bold uppercase tracking-wider mb-1
    ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}
  `;

  const sectionCardClass = `
    rounded-2xl border p-3.5 sm:p-4 transition-colors
    ${isDarkMode
      ? 'bg-slate-900/60 border-slate-800'
      : 'bg-white border-slate-200/90 shadow-2xs'
    }
  `;

  return (
    <Dialog
      open={Boolean(isopen)}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      disableAutoFocus={true}
      disableRestoreFocus={true}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: isDarkMode ? 'rgba(2, 6, 23, 0.75)' : 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
          }
        }
      }}
      PaperProps={{
        sx: {
          borderRadius: { xs: '16px', sm: '24px' },
          margin: { xs: '12px', sm: 'auto' },
          backgroundColor: isDarkMode ? '#0f172a' : '#ffffff',
          boxShadow: isDarkMode
            ? '0 25px 60px -15px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(99, 102, 241, 0.25)'
            : '0 25px 60px -15px rgba(15, 23, 42, 0.25)',
          overflow: 'hidden',
          border: isDarkMode ? '1px solid rgba(51, 65, 85, 0.8)' : '1px solid rgba(226, 232, 240, 0.8)',
        }
      }}
    >
      {/* Modal Header */}
      <DialogTitle className="!p-0 border-b border-slate-200/80 dark:border-slate-800">
        <div className="px-5 py-4 bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-700 text-white flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-white/15 backdrop-blur-sm flex items-center justify-center text-white shadow-xs">
              <Building2 size={20} />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h2 className="text-sm font-bold tracking-tight text-white">
                  Warehouse Details
                </h2>
                <span className={`inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full border ${
                  isEditMode
                    ? 'bg-amber-400/20 text-amber-200 border-amber-300/30'
                    : 'bg-white/15 text-white border-white/20'
                }`}>
                  {isEditMode ? (
                    <>
                      <span className="w-1.5 h-1.5 rounded-full bg-amber-300 animate-pulse" />
                      Editing Mode
                    </>
                  ) : (
                    <>
                      <Eye size={11} />
                      Viewing Mode
                    </>
                  )}
                </span>
              </div>
              <p className="text-[11px] text-indigo-100/90 mt-0.5">
                {isEditMode
                  ? 'Update facility information, contact points and address'
                  : 'Facility registration, contact information & return destinations'
                }
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={handleClose}
            aria-label="Close"
            className="w-8 h-8 rounded-xl bg-white/10 hover:bg-white/25 active:scale-95 text-white flex items-center justify-center transition-all"
          >
            <X size={16} />
          </button>
        </div>
      </DialogTitle>

      {/* Modal Body */}
      <DialogContent
        ref={contentRef}
        className={`!p-0 custom-scrollbar ${isDarkMode ? 'bg-slate-900/40 text-white' : 'bg-slate-50/50 text-slate-900'}`}
        style={{ maxHeight: 'calc(85vh - 130px)' }}
      >
        <form onSubmit={handleSubmit(onSubmit, onErrors)} className="p-4 sm:p-5 space-y-4">
          
          {/* Section 1: Primary Information */}
          <div className={sectionCardClass}>
            <div className="flex items-center justify-between pb-2.5 mb-3.5 border-b border-slate-100 dark:border-slate-800">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-lg bg-indigo-50 dark:bg-indigo-950/60 text-indigo-600 dark:text-indigo-400 flex items-center justify-center">
                  <Hash size={13} />
                </div>
                <h3 className="text-xs font-bold text-slate-800 dark:text-slate-200 uppercase tracking-wider">
                  Primary Information
                </h3>
              </div>
              <span className="text-[10px] font-bold text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-950/60 px-2 py-0.5 rounded-full border border-indigo-200 dark:border-indigo-800">
                Core ID
              </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
              <div>
                <label className={labelClass}>
                  <span>Warehouse ID</span>
                  <span className="flex items-center gap-0.5 text-[9px] text-slate-400 lowercase font-normal">
                    <Lock size={9} /> read-only
                  </span>
                </label>
                <div className="relative">
                  <input
                    type="text"
                    className={inputClass(false, Boolean(errors.Id))}
                    {...register('Id')}
                    disabled={isEditId}
                  />
                </div>
                {errors.Id && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.Id.message}</p>}
              </div>

              <div>
                <label className={labelClass}>
                  <span>Facility Name</span>
                  {isEditMode && <span className="text-rose-500">*</span>}
                </label>
                <div className="relative">
                  <input
                    type="text"
                    id="facility-name"
                    placeholder="Enter facility name"
                    className={inputClass(isEditMode, Boolean(errors.Name))}
                    {...register('Name')}
                    disabled={!isEditMode}
                  />
                </div>
                {errors.Name && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.Name.message}</p>}
              </div>
            </div>
          </div>

          {/* Section 2: Contact Information */}
          <div className={sectionCardClass}>
            <div className="flex items-center justify-between pb-2.5 mb-3.5 border-b border-slate-100 dark:border-slate-800">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-lg bg-sky-50 dark:bg-sky-950/60 text-sky-600 dark:text-sky-400 flex items-center justify-center">
                  <User size={13} />
                </div>
                <h3 className="text-xs font-bold text-slate-800 dark:text-slate-200 uppercase tracking-wider">
                  Contact Information
                </h3>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
              <div>
                <label className={labelClass}>
                  <span>Email Address</span>
                  <span className="flex items-center gap-0.5 text-[9px] text-slate-400 lowercase font-normal">
                    <Lock size={9} /> read-only
                  </span>
                </label>
                <input
                  type="email"
                  className={inputClass(false, Boolean(errors.email))}
                  {...register('email')}
                  disabled={isEditEmail}
                />
                {errors.email && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.email.message}</p>}
              </div>

              <div>
                <label className={labelClass}>
                  <span>Contact Person</span>
                  {isEditMode && <span className="text-rose-500">*</span>}
                </label>
                <input
                  type="text"
                  placeholder="Manager / Coordinator name"
                  className={inputClass(isEditMode, Boolean(errors.contact_person))}
                  {...register('contact_person')}
                  disabled={!isEditMode}
                />
                {errors.contact_person && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.contact_person.message}</p>}
              </div>

              <div>
                <label className={labelClass}>
                  <span>Phone Number</span>
                  {isEditMode && <span className="text-rose-500">*</span>}
                </label>
                <input
                  type="tel"
                  id="phone"
                  placeholder="10-digit mobile number"
                  className={inputClass(isEditMode, Boolean(errors.phone))}
                  {...register('phone')}
                  maxLength={10}
                  disabled={!isEditMode}
                />
                {errors.phone && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.phone.message}</p>}
              </div>

              <div>
                <label className={labelClass}>
                  <span>Creation Date</span>
                  <Calendar size={11} className="text-slate-400" />
                </label>
                <input
                  type="text"
                  className={inputClass(isEditMode, Boolean(errors.date))}
                  {...register('date')}
                  disabled={!isEditMode}
                />
                {errors.date && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.date.message}</p>}
              </div>
            </div>
          </div>

          {/* Section 3: Address Information */}
          <div className={sectionCardClass}>
            <div className="flex items-center justify-between pb-2.5 mb-3.5 border-b border-slate-100 dark:border-slate-800">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-lg bg-emerald-50 dark:bg-emerald-950/60 text-emerald-600 dark:text-emerald-400 flex items-center justify-center">
                  <MapPin size={13} />
                </div>
                <h3 className="text-xs font-bold text-slate-800 dark:text-slate-200 uppercase tracking-wider">
                  Address Information
                </h3>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
              <div className="sm:col-span-2">
                <label className={labelClass}>
                  <span>Street Address</span>
                  {isEditMode && <span className="text-rose-500">*</span>}
                </label>
                <input
                  type="text"
                  id="address"
                  placeholder="Complete location address"
                  className={inputClass(isEditMode, Boolean(errors.address))}
                  {...register('address')}
                  disabled={!isEditMode}
                />
                {errors.address && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.address.message}</p>}
              </div>

              <div>
                <label className={labelClass}>
                  <span>Pincode</span>
                  {isEditMode && <span className="text-rose-500">*</span>}
                </label>
                <input
                  type="text"
                  id="pincode"
                  placeholder="6-digit postal code"
                  className={inputClass(isEditMode, Boolean(errors.pincode))}
                  {...register('pincode')}
                  onChange={handleInputChange}
                  maxLength={6}
                  disabled={!isEditMode}
                />
                {errors.pincode && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.pincode.message}</p>}
              </div>

              <div>
                <label className={labelClass}>
                  <span>City</span>
                  {isEditMode && <span className="text-rose-500">*</span>}
                </label>
                <input
                  type="text"
                  id="city"
                  placeholder="City name"
                  className={inputClass(isEditMode, Boolean(errors.city))}
                  {...register('city')}
                  disabled={!isEditMode}
                />
                {errors.city && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.city.message}</p>}
              </div>

              <div>
                <label className={labelClass}>
                  <span>State</span>
                  {isEditMode && <span className="text-rose-500">*</span>}
                </label>
                <input
                  type="text"
                  id="state"
                  placeholder="State name"
                  className={inputClass(isEditMode, Boolean(errors.state))}
                  {...register('state')}
                  disabled={!isEditMode}
                />
                {errors.state && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.state.message}</p>}
              </div>

              <div>
                <label className={labelClass}>
                  <span>Country</span>
                  {isEditMode && <span className="text-rose-500">*</span>}
                </label>
                <input
                  type="text"
                  id="country"
                  placeholder="Country"
                  className={inputClass(isEditMode, Boolean(errors.country))}
                  {...register('country')}
                  disabled={!isEditMode}
                />
                {errors.country && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.country.message}</p>}
              </div>

              <div className="sm:col-span-2">
                <label className={labelClass}>
                  <span>Registered Business / Facility Name</span>
                  {isEditMode && <span className="text-rose-500">*</span>}
                </label>
                <input
                  type="text"
                  placeholder="Registered name"
                  className={inputClass(isEditMode, Boolean(errors.registerName))}
                  {...register('registerName')}
                  disabled={!isEditMode}
                />
                {errors.registerName && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.registerName.message}</p>}
              </div>
            </div>
          </div>

          {/* Section 4: Return Address Details */}
          <div className={sectionCardClass}>
            <div className="flex items-center justify-between pb-2.5 mb-3.5 border-b border-slate-100 dark:border-slate-800">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-lg bg-amber-50 dark:bg-amber-950/60 text-amber-600 dark:text-amber-400 flex items-center justify-center">
                  <RotateCcw size={13} />
                </div>
                <h3 className="text-xs font-bold text-slate-800 dark:text-slate-200 uppercase tracking-wider">
                  Return Address Details
                </h3>
              </div>
              <span className="text-[10px] font-semibold text-slate-400">
                RTO Facility
              </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
              <div className="sm:col-span-2">
                <label className={labelClass}>Return Address</label>
                <input
                  type="text"
                  id="returnAddress"
                  placeholder="Return warehouse address"
                  className={inputClass(isEditMode, Boolean(errors.returnAddress))}
                  {...register('returnAddress')}
                  disabled={!isEditMode}
                />
                {errors.returnAddress && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.returnAddress.message}</p>}
              </div>

              <div>
                <label className={labelClass}>Return Pincode</label>
                <input
                  type="text"
                  id="return-pincode"
                  placeholder="Return postal code"
                  className={inputClass(isEditMode, Boolean(errors.returnPincode))}
                  {...register('returnPincode')}
                  onChange={handleInputChange}
                  maxLength={6}
                  disabled={!isEditMode}
                />
                {errors.returnPincode && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.returnPincode.message}</p>}
              </div>

              <div>
                <label className={labelClass}>Return City</label>
                <input
                  type="text"
                  id="returnCity"
                  placeholder="Return city"
                  className={inputClass(isEditMode, Boolean(errors.returnCity))}
                  {...register('returnCity')}
                  disabled={!isEditMode}
                />
                {errors.returnCity && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.returnCity.message}</p>}
              </div>

              <div>
                <label className={labelClass}>Return State</label>
                <input
                  type="text"
                  id="returnState"
                  placeholder="Return state"
                  className={inputClass(isEditMode, Boolean(errors.returnState))}
                  {...register('returnState')}
                  disabled={!isEditMode}
                />
                {errors.returnState && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.returnState.message}</p>}
              </div>

              <div>
                <label className={labelClass}>Return Country</label>
                <input
                  type="text"
                  placeholder="Return country"
                  className={inputClass(isEditMode, Boolean(errors.returnCountry))}
                  {...register('returnCountry')}
                  disabled={!isEditMode}
                />
                {errors.returnCountry && <p className="text-rose-500 text-[10.5px] mt-1 flex items-center gap-1"><AlertCircle size={11} /> {errors.returnCountry.message}</p>}
              </div>
            </div>
          </div>

          {/* Action Buttons (Sticky at bottom of form) */}
          <div className={`sticky bottom-0 z-10 px-4 py-3 -mx-4 sm:-mx-5 -mb-4 sm:-mb-5 border-t flex items-center justify-between gap-3 backdrop-blur-md ${
            isDarkMode ? 'bg-slate-900/95 border-slate-800' : 'bg-white/95 border-slate-200'
          }`}>
            <div className="text-[11px] text-slate-400">
              {isEditMode ? (
                <span className="text-amber-500 font-semibold flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse" />
                  Editing active
                </span>
              ) : (
                <span className="text-slate-500 dark:text-slate-400">
                  ID: <span className="font-mono font-semibold text-slate-800 dark:text-slate-200">{warehouse?.id || '—'}</span>
                </span>
              )}
            </div>

            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={hanldeAllEditFileds}
                className={`px-4 py-2 rounded-xl text-xs font-bold transition-all active:scale-95 flex items-center gap-1.5 border ${
                  isEditMode
                    ? 'border-slate-300 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-700 dark:text-slate-300'
                    : 'bg-indigo-50 dark:bg-indigo-950/60 border-indigo-200 dark:border-indigo-800 text-indigo-600 dark:text-indigo-400 hover:bg-indigo-100 dark:hover:bg-indigo-900/60'
                }`}
              >
                {isEditMode ? (
                  <>
                    <X size={13} /> Cancel Editing
                  </>
                ) : (
                  <>
                    <Edit3 size={13} /> Edit Warehouse
                  </>
                )}
              </button>

              {(isEditMode && isEditId && isEditEmail) && (
                <button
                  type="submit"
                  className="px-5 py-2 rounded-xl text-xs font-bold bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 text-white shadow-md shadow-emerald-600/30 flex items-center gap-1.5 active:scale-95 transition-all"
                >
                  <Save size={13} /> Save Changes
                </button>
              )}
            </div>
          </div>

        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ViewWarehouse;